module.exports = __webpack_public_path__ + "img/galeria-forestales-2.f212cba5.jpg";